import {isFeatureEnabled} from '@github-ui/feature-flags'

import styles from './LayoutHelpers.module.css'

export function wrapElement(
  wrappedElement: React.ReactNode,
  // In case of Timelinetem, this represent the avatar for an IssueComment event
  leadingElement?: React.ReactNode,
  key?: string,
) {
  const inlineAvatars = isFeatureEnabled('issue_inline_avatars')
  return (
    <div
      className={`${styles.timelineElement} ${leadingElement ? '' : inlineAvatars ? styles.nonLeadingElement_inlineAvatars : styles.nonLeadingElement}`}
      key={key}
      data-wrapper-timeline-id={key}
    >
      {leadingElement}
      {wrappedElement}
    </div>
  )
}
